<template>
    <div ref="stick"/>
</template>

<script>
  import nipplejs from "nipplejs";

  export default {
    name: "VirtualStick",
    data() {
      return {
        stick: null,
        radius: 0,
        angle: 0,
      }
    },
    mounted() {
        let screenSize = window.screen.width

        if (screenSize < window.screen.height) {
          screenSize = window.screen.height
        }

        let percentageSize = 15;

        if (screenSize > 1200) {
          percentageSize = 10;
        }

        const size = screenSize * percentageSize / 100;

        this.stick = nipplejs.create({
            zone: this.$refs.stick,
            multitouch: true,
            mode: 'static',
            size: size,
            color: 'white'
        });

        this.stick.on('move', function(event, data) {
            // normalize to 1
            this.radius = Math.min(data.force, 1);
            this.angle = data.angle.radian;
        }.bind(this));

        this.stick.on('end', function() {
            // user released the joystick, reset to 0
            this.radius = 0;
            this.angle = 0;
        }.bind(this));
    }
  }
</script>

<style scoped>

</style>
